<template>
  <div class="clazz_review" v-if="clazz">
    <clazz-show-header :clazz="clazz" />

    <div class="header bgwhite mt15">
      <div class="left">审核打卡</div>
      <!-- <div class="right" @click="gotoRule">规则</div> -->
    </div>

    <record-panel
      v-if="record"
      class="bgwhite"
      :record="record"
      @refresh="onRefreshTab"
      :has-footer="false"
      :has-toolbar="true"
    />

    <div v-else class="empty bgwhite no_record">当前无可审核记录</div>

    <bottom-btn
      v-if="record"
      title="下一个"
      :fixed="true"
      @click.native="gotoNext"
    />

  </div>
</template>

<script>
import { Toast } from 'vant'
import ClazzShowHeader from '@/views/clazz/components/ClazzShowHeader'
import RecordPanel from '@/views/record/components/RecordPanel'
import BottomBtn from '@/components/BottomBtn'
import { clazzSimpleInfo } from '@/api/clazz'
import { reviewRecordOne } from '@/api/record'

export default {
  name: 'JoinClazzReview',
  components: {
    ClazzShowHeader,
    RecordPanel,
    BottomBtn
  },
  data () {
    return {
      clazz: null,
      record: null
    }
  },
  created () {
    this.clazzId = this.$route.params.clazz_id || ''
    this.getClazzInfo()
    this.getRecord()
  },
  methods: {
    async getClazzInfo () {
      let response = await clazzSimpleInfo(this.clazzId)
      this.clazz = response.data
    },
    async getRecord (recordId) {
      let response = await reviewRecordOne(this.clazzId, { record_id: recordId })
      Toast.clear()
      this.record = response.data
    },
    onRefreshTab (record) {
      this.gotoNext()
    },
    gotoRule () {
    },
    gotoNext () {
      const recordId = this.record.uuid
      Toast.loading({ duration: 3000, forbidClick: true, loadingType: 'spinner' })
      this.getRecord(recordId)
    }
  }
}
</script>

<style scoped lang="scss">
.clazz_review {
  background-color: #f8f8f8;
  .header {
    display: flex;
    justify-content: space-between;
    padding: 20px 30px;
    .left {
      font-size: 30px;
      font-weight: bold;
    }
    .right {
      font-size: 28px;
      color: #5990AC;
    }
  }
  .no_record {
    padding-top: 60px;
  }
}
</style>
